/* tslint:disable:object-literal-shorthand */
import {ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {IExgTab} from 'exc-tab-v2';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgDataListComponent, ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {ExgTabV2Component, ExgTabV2ComponentHeaderElement} from '../../misc/exg-tab-v2/exg-tab-v2.component';
import {EnumerationService} from '../../services/enumeration.service';
import {NestedTreeControl} from '@angular/cdk/tree';
import {ApplicationService} from '../../services/application.service';
import {IExgEvent} from '../../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {DataService} from '../../services/data.service';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ITaskSummaryData} from '../../misc/interfaces/ITaskSummaryData';
import {ExcSecurityService} from 'exc-security-v2';
import {BehaviorSubject, Observable} from 'rxjs';
import {TaskDataService} from '../../services/task-data.service';
import {CaseDataService} from '../../services/case-data.service';

@Component({
  selector: 'app-task-workspace',
  templateUrl: './task-workspace-v2.component.html',
  styles: []
})
export class TaskWorkspaceV2Component extends ExcTranslation implements OnInit, IExgTab, IExgEvent {
  @ViewChild('VCrightTabControl', {read: ExgTabV2Component}) VCrightTabControl!: ExgTabV2Component;

  @ViewChild('DivDetails', {read: ElementRef}) DivDetails!: ElementRef;
  @ViewChild('DivDetails2', {read: ElementRef}) DivDetails2!: ElementRef;
  @ViewChild('DivSchedule', {read: ElementRef}) DivSchedule!: ElementRef;
  @ViewChild('DivVerlauf', {read: ElementRef}) DivVerlauf!: ElementRef;

  @ViewChild('VCVorganglist', {read: ExgDataListComponent}) VCVorganglist!: ExgDataListComponent;
  @ViewChild('PhotoDocList', {read: ExgDataListComponent}) PhotoDocList!: ExgDataListComponent;
  @ViewChild('VCJournalMailList', {read: ExgDataListComponent}) VCJournalMailList!: ExgDataListComponent;

  Events = new ExgApplicationEventEmitter();
  dataSummaryLoaded = new BehaviorSubject(false);

  Data: any;
  tabinstance: any;
  vorgCHK = 0;

  rightDrawerVisible = false;
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];
  leftTabs: ExgTabV2ComponentHeaderElement[] = [];
  init = true;
  workFlowMenu: any[] = [];

  openReportFolder: string[] = [];
  openAttachmentFolder: string[] = [];
  //#region TaskSummary
  TaskSummary: ITaskSummaryData | any = this.dataSvc.Task.Summary.Get();
  config = {
    leistungList: {
      selectKey: 'leID',
      state: 1,
      searchValue: '',
      selectedRow: undefined as any,
      isLoading: false
    },
    receiptList: {
      treeControl: new NestedTreeControl<any>(node => node.receipts),
      selectKey: 'rcptID',
      state: 1,
      selectedRow: undefined as any,
      uiFilter: [
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'Neu',
          filterCondition: {operator: '=', value: 1},
          uiName: 'Neu',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'In Bearbeitung',
          filterCondition: {operator: '=', value: 2},
          uiName: 'InBearbeitung',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'Zur Prüfung',
          filterCondition: {operator: '=', value: 3},
          uiName: 'ZurPrüfung',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'In Prüfung',
          filterCondition: {operator: '=', value: 4},
          uiName: 'InPrüfung',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'freigegeben',
          filterCondition: {operator: '=', value: 10},
          uiName: 'fertiggemeldet',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'Abgelehnt',
          filterCondition: {operator: '=', value: 20},
          uiName: 'Abgelehnt',
          uiValue: false
        }],
      uiSort: [
        {
          sortField: 'rcptCRD', sortDefault: 0, uiCaption: 'letzte Erstellung',
          uiValue: false
        },
        {
          sortField: 'rcptLCD', sortDefault: 0, uiCaption: 'letzte Änderung',
          uiValue: true
        }],
      isLoading: true,
      ready: () => {
        if (!this.TaskSummary?.receiptList?.data || this.TaskSummary?.receiptList?.data.length === 0) {
          this.config.receiptList.state = 2;
          // this.VCreceiptList.selectedRow = -1;
        } else {
          this.config.receiptList.state = 0;
          // this.VCreceiptList.selectedRow = 0;
        }
        this.config.receiptList.isLoading = false;
      },
      hasChild: (_: number, node: any): boolean => {
        return !!node.receipts && node.receipts.length > 0;
      },
      deleteReceipt: (event: any, rcptID: any, rcptUPT: any, rcptState: number) => {
        const SELF = this;

        event.preventDefault();
        event.stopPropagation();

        if (rcptState <= 2 || this.excSecurity.isFeatured('RECEIPTDELETE')) {
          SELF.modal.showSimple(
            this.getRessource('DeleteReceipt.Title'),
            this.getRessource('DeleteReceipt.Message'),
            true,
            true,
            this.getGlobal('Delete'),
            this.getGlobal('Cancel'),
          ).subscribe((rtVal: boolean) => {
            if (rtVal) {
              SELF.config.receiptList.state = 1;
              SELF.config.receiptList.isLoading = true;
              SELF.excRest
                .delete(
                  SELF.excRest.computeUrl('ReceiptD', {rcptID}), {rcptUPT}, {})
                .subscribe(
                  (ret: any) => {
                    if (ret) {
                      if (ret) {
                        this.modal
                          .showToast(
                            ret.success
                              ? `${this.getGlobal('Success')} ${this.getGlobal('Delete')}`
                              : this.getGlobal('Cancel')
                            , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                            , ret.success ? 'fal fa-trash-can-check' : 'fal fa-times-circle');
                      }
                      this.Events?.Receipt?.List?.Deleted?.emit({success: ret});
                    }
                  }
                );
            }
          });
        }
      }
    },
    flowTable: {
      state: 1,
      ready: () => {
        if (!this.TaskSummary?.flowTable.data || this.TaskSummary?.flowTable.data.length === 0) {
          this.config.flowTable.state = 2;
        } else {
          this.config.flowTable.state = 0;
        }
      },
    },
    attachmentJagTable: {
      state: 1,
      ready: () => {
        if (!this.TaskSummary?.attachmentJagTable.data || this.TaskSummary?.attachmentJagTable?.isEmpty) {
          this.config.attachmentJagTable.state = 2;
        } else {
          this.config.attachmentJagTable.state = 0;
        }
      },

      hasChild: (_: number, node: any): boolean => {
        return !!node.documents && node.documents.length > 0;
      },

      treeControl: new NestedTreeControl<any>(node => node.documents),
    },
    worklist: {
      selectedRow: undefined as any,
      selectKey: 'apiID',
      selectionChanged: (index: number) => {
        this.config.worklist.selectedRow =
          this.TaskSummary?.workList?.data[index];
      },
    },
    taskList: {
      selectedObjects: [] as any[],
      rowChange: (index: number) => {
        if (!this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.TaskSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects = [];
          this.config.taskList.selectedObjects.push(this.TaskSummary?.taskList?.data[index]);
        } else {
          this.VCVorganglist.selectedRow = -1;
          this.config.taskList.selectedObjects = [];
        }
      },
      itemSelect: (index: number) => {
        if (this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.TaskSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects =
            this.config.taskList.selectedObjects.filter((sOrt: any) => sOrt !== this.TaskSummary?.taskList?.data[index]);
        } else {
          this.config.taskList.selectedObjects.push(this.TaskSummary?.taskList?.data[index]);
        }
      },
    },
    photoDocumentation: {
      selectedObjects: [] as any[],
      isLoading: false,
    },

    getOEByID: (ID: string): any => {
      return ExcCoreModule.Array.GetObject(this.TaskSummary?.oeList?.data, 'oeID', ID);
    },

    newMessage: (): void => {
      this.appSvc.Message.NewForTask.OpenTab({objID: this.TaskSummary?.ID}, {Events: this.Events});
    },

    newDefaultMessage: (dmsgID: any): void => {
      this.appSvc.Message.NewForTask.OpenTab({objID: this.TaskSummary?.ID, dmsgID: dmsgID}, {Events: this.Events});
    },

    newServiceRecord: (): void => {
      this.appSvc.Leistungserfassung.New(
        {fkID: this.TaskSummary?.ID, fkType: 'Vorgang'},
        {Events: this.Events}
      );
    },

    newReport: (): void => {
      this.appSvc.Report.New(this.TaskSummary?.ID, {Events: this.Events});
    },

    newNote: (): void => {
      this.appSvc.Note.OpenModal({ntz_objID: this.TaskSummary?.ID}, {Events: this.Events});
    },

    showUploadReceiptModal: (): void => {
      this.appSvc.Receipt.Upload.OpenModal(
        {
            Data: {
              rcpt_vorgID: this.TaskSummary?.ID
              , rcptStatement: false
            },
            SummaryAttachmentTable: this.TaskSummary?.attachmentJagTable,
            ConfigAttachmentTable: this.config.attachmentJagTable
          },
        {Events: this.Events}
      );
    },

    showUploadStatementModal: (): void => {
      this.appSvc.Receipt.Upload.OpenModal(
        {
          Data: {
            rcpt_vorgID: this.TaskSummary?.ID
            , rcptStatementReason: this.TaskSummary?.taskDetails?.data?.vorgBeschreibung
            , rcptStatement: true
          },
          SummaryAttachmentTable: this.TaskSummary?.attachmentJagTable,
          ConfigAttachmentTable: this.config.attachmentJagTable
        },
        {Events: this.Events}
      );
    },

    showHistory: (): void => {
      this.appSvc.History.OpenModal(this.TaskSummary?.historyTable?.data);
    },
    showAttachmentUploadModal: (): void => {
      this.appSvc.Document.Upload.OpenModal({dok_objID: this.TaskSummary?.ID}, {Events: this.Events});
    },

    documentTemplateDownload: (dotID: string): void => {
      this.appSvc.DocumentTemplate.Download(this.TaskSummary?.ID, dotID);
      this.TaskSummary?.LoadSummary();
    },

    showAttachmentPreview: (dokID?: string): void => {
      this.appSvc.Document.Preview.OpenModal({objID: this.TaskSummary?.ID, attID: dokID}, {Events: this.Events});
    },

    openCheckViewCollection: (): void => {
      if (this.config.receiptList.selectedRow) {
        this.appSvc.Receipt.Checkview.OpenCollectionTab({
          rcptID:
            this.config.receiptList.selectedRow[
              this.config.receiptList.selectKey
              ],
        });
      }
    },

    onDblClickCheckView: (index: number): void => {
      if (this.config.receiptList.selectedRow) {
        this.appSvc.Receipt.Checkview.OpenTab(
          this.TaskSummary?.receiptList?.data[index].rcptID
        );
      }
    },

    openCheckView: (): void => {
      if (this.config.receiptList.selectedRow) {
        this.appSvc.Receipt.Checkview.OpenTab(
          this.config?.receiptList?.selectedRow?.rcptID
        );
      }
    },

    receiptCaseOpenTestReportPdf: (): void => {
      if (this.TaskSummary?.receiptList?.data?.length > 0) {
        this.appSvc.Receipt.Reporting.openCaseReport(
          this.TaskSummary?.caseDetails?.data?.auID,
          true
        );
      }
    },

    receiptTaskOpenTestReportPdf: (): void => {
      if (this.TaskSummary?.receiptList?.data?.length > 0) {
        this.appSvc.Receipt.Reporting.openTaskReport(this.TaskSummary?.ID, true);
      }
    },

    downloadPhotoDocumentation: (pdID: string): void => {
      this.config.photoDocumentation.isLoading = true;
      this.appSvc.PhotoDocumentation.Download(pdID, {Events: this.Events});
    }
  };
  userType: number | any;
  showApiDivTable = true;

  //#endregion TaskSummary

  //#region VorgangsEditierung
  editFunctions = {
    editMode: false,
    editTaskModel: {
      vorgID: '',
      vorg_enmIdent_VorgangTyp: 0,
      vorg_enmName_VorgangTyp: '',
      vorgVorgangSubTyp_enmIdent: 0,
      vorgVorgangSubTyp_enmName: '',
      vorgBeschreibung: '',
      vorgUPT: ''
    } as { [key: string]: any },
    resetEditTaskModel(originalTaskModel: any): void {
      this.editTaskModel = {
        vorgID: '',
        vorg_enmIdent_VorgangTyp: 0,
        vorg_enmName_VorgangTyp: '',
        vorgVorgangSubTyp_enmIdent: 0,
        vorgVorgangSubTyp_enmName: '',
        vorgBeschreibung: '',
        vorgUPT: ''
      };
      for (const key in this.editTaskModel) {
        /* Copy every relevant attribute^ to Model*/
        if (originalTaskModel[key] !== undefined) {
          this.editTaskModel[key] = originalTaskModel[key];
        }
      }
    },
    compareEditTaskModels(originalTaskModel: any): boolean {
      for (const key in this.editTaskModel) {
        if (originalTaskModel[key] !== this.editTaskModel[key]) {
          return true; // Wenn ein Unterschied gefunden wurde, geben Sie true zurück
        }
      }
      return false; // Wenn kein Unterschied gefunden wurde, geben Sie false zurück
    },
    enterEditMode(originalTaskModel: any): void {
      this.resetEditTaskModel(originalTaskModel);
      this.editMode = true;
    },
    cancelEdit(originalTaskModel: any): void {
      this.resetEditTaskModel(originalTaskModel);
      this.editMode = false;
    }
  };
  private _selectedVorgangTypIndex = 0;
  get selectedVorgangTypIndex(): number {
    const enumListIdents =
      this.enumSvc.getEnumerationList(this.editFunctions?.editTaskModel?.vorg_enmName_VorgangTyp).map(a => (a.enmIdent));
    const currentIdent = this.editFunctions.editTaskModel.vorg_enmIdent_VorgangTyp;
    return enumListIdents.indexOf(currentIdent);
  }

  set selectedVorgangTypIndex(selectedIndex: number) {
    /*change the Model displayed to the selected Type*/
    const enumListIdents =
      this.enumSvc.getEnumerationList(this.editFunctions?.editTaskModel?.vorg_enmName_VorgangTyp).map(a => (a.enmIdent));
    this._selectedVorgangTypIndex = selectedIndex;
    this.editFunctions.editTaskModel.vorg_enmIdent_VorgangTyp = enumListIdents[selectedIndex];
    /*the selected Type influences the subtype select with enmSelector = enmName*/
    const enumSelectorList =
      this.enumSvc.getEnumerationList(this.editFunctions?.editTaskModel?.vorg_enmName_VorgangTyp).map(a => (a.enmSelector));
    if (this.editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName !== enumSelectorList[selectedIndex]) {
      this.editFunctions.editTaskModel.vorgVorgangSubTyp_enmName = enumSelectorList[selectedIndex];
      this.selectedVorgangSubTypIndex = 0;
    }
  }

  private _selectedVorgangSubTypIndex = 0;
  get selectedVorgangSubTypIndex(): number {
    const enumListIdents =
      this.enumSvc.getEnumerationList(this.editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName).map(a => (a.enmIdent));
    const currentIdent = this.editFunctions.editTaskModel.vorgVorgangSubTyp_enmIdent;
    return enumListIdents.indexOf(currentIdent);
  }

  set selectedVorgangSubTypIndex(selectedIndex: number) {
    this.editFunctions.editTaskModel.vorgVorgangSubTyp_enmIdent = selectedIndex;
  }

  constructor(public excRest: ExcRestService,
              public chDecRef: ChangeDetectorRef,
              public modal: ExgModalService,
              private overlaySrv: ExgOverlayService,
              public enumSvc: EnumerationService,
              public appSvc: ApplicationService,
              private dataSvc: DataService,
              public excSecurity: ExcSecurityService,
              private renderer: Renderer2,
              private caseDataSvc: CaseDataService,
              private taskDataSvc: TaskDataService) {
    super();
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      if (this.tabinstance.Active) {
        this.TaskSummary?.LoadSummary();
      }
    });
    ExcCoreModule.Services().StrgI.subscribe(() => {
      if (this.tabinstance.Active) {
        this.rightDrawerVisible = !this.rightDrawerVisible;
      }
    });
    this.dataSummaryLoaded.subscribe(async (temp) => {
      const SELF = this;
      if (temp) {
        await new Promise(f => setTimeout(f, 3000));
      }
      this.apiWarnings();
    });
    this.Events.Leistungserfassung?.New?.Save?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Message?.NewForTask?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Calculation?.Version?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.NoteDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Receipt?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Receipt?.List?.Deleted?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Document?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Document?.UpdateDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Formular?.Version?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Receipt?.Preview?.Downloaded?.subscribe((evt: ExgEventArgs) => {
      this.config.receiptList.isLoading = false;
    });
    this.Events.Schedule?.UpdateSchedule?.Closed?.subscribe(() => {
      this.init = true;
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Schedule?.CreateSchedule?.Closed?.subscribe(() => {
      this.init = true;
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Task?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.config.receiptList.ready();
        this.config.flowTable.ready();
        this.config.attachmentJagTable.ready();
        this.tabinstance.Label = this.TaskSummary?.taskDetails?.data?.vorgNr;
        this.init = false;
        this.dataSummaryLoaded.next(true);
        const SELF = this;
        SELF.workFlowMenu = [
          {
            // Vorgang speichern
            security: 'TASKEDIT',
            get caption(): string {
              return SELF.getResource('Workflow.Save');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
            }
          },
          {
            // Vorgang geprüft markieren
            security: 'TASKCHECK',
            get caption(): string {
              return SELF.getResource('Workflow.TaskCheck');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.Check(SELF.TaskSummary?.taskDetails?.data).subscribe((response: any) => {
                if (response && response.success) {
                  SELF.TaskSummary.LoadSummary();
                }
              });
            }
          },
          {
            // Vorgang disponieren (Bearbeiter auswählen)
            security: 'TASKDISPO',
            get caption(): string {
              return SELF.getResource('Workflow.TaskAssign');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.changeEditor();
            }
          },
          {
            // Vorgang Editor entfernen (Bearbeiter entfernen)
            security: 'TASKDISPO',
            get caption(): string {
              return SELF.getResource('Workflow.TaskRemoveEditor');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.ChangeEditor(SELF.TaskSummary?.taskDetails?.data, '00000000-0000-0000-0000-000000000000')
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary();
                });
            }
          },
          {
            // Vorgang annehmen
            security: 'TASKACCEPT',
            get caption(): string {
              return SELF.getResource('Workflow.TaskAccept');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 2;
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.Accept(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary(response);
                });
            }
          },
          {
            // Vorgang ablehnen
            security: 'TASKDECLINE',
            get caption(): string {
              return SELF.getResource('Workflow.TaskDecline');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 2;
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.Decline(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary(response);
                });
            }
          },
          {
            // Vorgang fertig melden
            security: 'TASKFINISH',
            get caption(): string {
              return SELF.getResource('Workflow.TaskFinish');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && (
                    SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 4
                    || SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 14
                  );
              }
              return this._visible;
            },
            click: (): void => {
              this.taskStateChange({
                title: 'Vorgang: fertig melden',
                message: 'Nach dem angeforderten Statuswechsel ist der Vorgang nur noch eingeschränkt bearbeitbar. Sind Sie sicher, dass Sie den Vorgang fertig melden möchten?',
                actions: [
                  {btnText: 'fertig melden', disabled: false, rtValue: true}
                ]
              }).subscribe((accepted: boolean) => {
                if (accepted) {
                  SELF.taskDataSvc.Task.Finish(SELF.TaskSummary?.taskDetails?.data)
                    .subscribe((response: any) => {
                      SELF.TaskSummary?.LoadSummary(response);
                    });
                }
              });
            }
          },
          {
            // Vorgang an QS senden
            security: 'TASKSENDTOQS',
            get caption(): string {
              return SELF.getResource('Workflow.SendToQS');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && (
                    SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 4
                    || SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 14
                  )
                  && SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangTyp !== 11;
              }
              return this._visible;
            },
            click: (): void => {
              this.taskStateChange({
                title: 'Vorgang an QS senden',
                message: 'Nach dem angeforderten Statuswechsel ist der Vorgang nur noch eingeschränkt bearbeitbar. Sind Sie sicher, dass Sie den Vorgang an QS senden möchten?',
                actions: [
                  {btnText: 'an QS senden', disabled: false, rtValue: true}
                ]
              }).subscribe((accepted: boolean) => {
                if (accepted) {
                  SELF.taskDataSvc.Task.SendToQS(SELF.TaskSummary?.taskDetails?.data)
                    .subscribe((response: any) => {
                      SELF.TaskSummary?.LoadSummary(response);
                    });
                }
              });
            }
          },
          {
            // Vorgang zur Bearbeitung zurückgeben
            security: 'TASKQSRETURN',
            get caption(): string {
              return SELF.getResource('Workflow.QSReturn');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && (
                    SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 4
                    || SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 14
                  )
                  && SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangTyp === 11;
              }
              return this._visible;
            },
            click: (): void => {
              this.taskStateChange({
                title: 'Vorgang zur Bearbeitung zurückgeben',
                message: 'Nach dem angeforderten Statuswechsel wird er Ursprungsvorgang wieder geöffne und dieser Vorgang fertig gemeldet. Sind Sie sicher, dass Sie den Vorgang zur Überarbeitung geben möchten?',
                actions: [
                  {btnText: 'zur Überarbeitung', disabled: false, rtValue: true}
                ]
              }).subscribe((accepted: boolean) => {
                if (accepted) {
                  SELF.taskDataSvc.Task.QSReturn(SELF.TaskSummary?.taskDetails?.data)
                    .subscribe((response: any) => {
                      SELF.TaskSummary?.LoadSummary(response);
                    });
                }
              });
            }
          },
          {
            // Vorgang zur Bearbeitung zurückgeben
            security: 'TASKFINALFINISH',
            get caption(): string {
              return SELF.getResource('Workflow.TaskFinalFinish');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && ExcCoreModule.Services().ExcSecurityService.isFeatured('TASKSTATCHANGE')
                  && SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus <= 6;
              }
              return this._visible;
            },
            click: (): void => {
              this.modal.showSimple(
                'Vorgang abschließen',
                'Dieser Vorgang wird abgeschlossen und alle Ablaufplanpunkte werden freigegeben. Sind Sie sicher, dass Sie den Vorgang abschließen möchten?',
                true,
                true,
                'Abschließen',
                this.getGlobal('Cancel')
              ).subscribe((accepted: boolean) => {
                if (accepted) {
                  SELF.taskDataSvc.Task.FinalFinish(SELF.TaskSummary?.taskDetails?.data)
                    .subscribe((response: any) => {
                      SELF.TaskSummary?.LoadSummary(response);
                    });
                }
              });
            }
          },
          {
            // Vorgang stornieren
            security: 'TASKCANCEL',
            get caption(): string {
              return SELF.getResource('Workflow.TaskCancel');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              const task = SELF.TaskSummary.taskDetails.data;
              const enumList = SELF.enumSvc.getEnumerationList('VorgangStatus');

              const cancelStatusEnum = enumList.filter((e: any) => e.enmIdent === 9);

              if (task && cancelStatusEnum?.length > 0) {
                SELF.modal.show('ModalTaskStateChangeCommentComponent', {
                  taskState: 9,
                  enums: cancelStatusEnum,
                  isCancelOnly: true
                }).subscribe((modalResponse: any) => {
                  if (modalResponse && modalResponse.selectedStateEnmIdent) {
                    SELF.taskDataSvc.Task.ManualStateChange(
                      SELF.TaskSummary.taskDetails.data,
                      modalResponse.selectedStateEnmIdent,
                      modalResponse.stateChangeComment
                    ).subscribe(() => {
                      SELF.TaskSummary?.LoadSummary();
                      SELF.modal.showToast(
                        'Vorgang storniert',
                        'md-toast bg-green',
                        'fas fa-check-circle'
                      );
                    });
                  }
                });
              }
            }
          },
          {
            // Vorgang sperren
            security: 'VORGL',
            get caption(): string {
              return SELF.getResource('Workflow.TaskLock');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && false;
              }
              return this._visible;
            },
            click(): void {
            }
          },
          {
            // Ablaufplan erstellen
            security: 'SCHEDULEINIT',
            get caption(): string {
              return SELF.getResource('Workflow.TaskCreateAP');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.InitSchedule(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary(response);
                });
            }
          },
          {
            // Dokumentenmanagement
            security: 'DOCUMENTMGMT',
            get caption(): string {
              return SELF.getResource('Workflow.DocumentManagement');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && false;
              }
              return this._visible;
            },
            click(): void {
            }
          },
          {
            // An Exakt:App senden (Motionscloud)
            security: 'TASK2APP',
            get caption(): string {
              return SELF.getResource('Workflow.SendToExaktApp');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.SendToApp(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary(response);
                });
            }
          },
          {
            // Fragen beantworten
            security: '',
            get caption(): string {
              return SELF.getResource('Workflow.AnswerQuestions');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && (!SELF.TaskSummary || SELF.TaskSummary?.dialogueQuestions?.data?.length > 0);
              }
              return this._visible;
            },
            click(): void {
              SELF.openDialogueQuestions();
            }
          },
          {
            // QS-Regulierungsvereinbarung/Kurzbericht abschließen
            security: 'TASKQSREGFINISH',
            get caption(): string {
              return SELF.getResource('Workflow.QSFinish');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && (
                    SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 4
                    || SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 14
                  )
                  && SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangTyp === 24;
              }
              return this._visible;
            },
            click(): void {
              this.taskStateChange({
                title: 'QS-Regulierungsauftrag abschließen',
                message: 'Nach dem angeforderten Statuswechsel ist der Vorgang nur noch eingeschränkt bearbeitbar. Sind Sie sicher, dass Sie die QS-Regulierungsauftrag abschließen möchten?',
                actions: [
                  {btnText: 'Abschließen', disabled: false, rtValue: true}
                ]
              }).subscribe((accepted: boolean) => {
                if (accepted) {
                  SELF.taskDataSvc.Task.QSRegFinish(SELF.TaskSummary?.taskDetails?.data)
                    .subscribe((response: any) => {
                      SELF.TaskSummary?.LoadSummary(response);
                    });
                }
              });
            }
          },
          {
            security: 'TASKCONTATTEMPT',
            get caption(): string {
              return SELF.getResource('Workflow.ContactAttempt');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click: (): void => {
              this.openModalContactAttempt();
            }
          },
          {
            // An mich disponieren
            security: 'TASKDISPO2ME',
            get caption(): string {
              return SELF.getResource('Workflow.AssignToMe');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.DispoToMe(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary();
                });
            }
          },
          {
            // Status manuell ändern
            security: 'TASKSTATCHANGE',
            get caption(): string {
              return 'Status manuell ändern';
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click: (): void => {
              this.openTaskStateModal();
            },
          }/*,
      {
        // Editieren
        security: '*',
        get caption(): string {
          return SELF.getResource('Workflow.EditFields');
        },
        get visible(): boolean {
          return ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
        },
        click(): void {
          SELF.editMode = true;
        }
      }*/
        ];
      }
    });
    this.Events.DialogueQuestion.DataLoaded.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        const x = evt.data.find((e: any) => {
          return e.dfPflichtfeld && (!e.deValue || e.deValue === '');
        });
        if (this.init && x) {
          this.openDialogueQuestions();
        }
      }
    });
    this.Events.Questionnaire?.CreateUpdateVersion?.Closed?.subscribe((ret: any) => {
      if (ret?.success) {
        this.TaskSummary?.LoadSummary();
      }
    });
    this.Events.PhotoDocumentation?.Download?.Finished?.subscribe((ret: any) => {
      if (ret?.success) {
        this.config.photoDocumentation.isLoading = false;
        this.modal.showToast('Download erfolgreich', 'md-toast', 'fas fa-check');
      } else {
        this.config.photoDocumentation.isLoading = false;
        this.modal.showToast('Download fehlgeschlagen', 'md-toast', 'fas fa-exclamation');
      }
    });
    this.Events.Message.Reader.LinkChanged?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
  }

  openModalContactAttempt(): void {
    if (this.excSecurity.isFeatured('TASKCONTATTEMPT')) {
      this.modal.show('ModalContactAttemptComponent', {
        taskId: this.TaskSummary?.taskDetails?.data?.vorgID,
        caseId: this.TaskSummary?.caseDetails?.data?.auID
      }).subscribe((modalResult: any) => {
        if (modalResult && modalResult.success) {
          this.taskDataSvc.Task.ContactAttempt(
            this.TaskSummary?.taskDetails?.data,
            this.TaskSummary?.caseDetails?.data, {
              contactDateTime: modalResult.contactDateTime,
              comment: modalResult.comment
            }).subscribe((response: any) => {
            if (response && response.success) {
              this.TaskSummary?.LoadSummary();
              this.modal.showToast(this.getRessource('ContactAttempt.Success'), 'md-toast bg-green', 'fas fa-check');
            } else {
              this.modal.showToast(this.getRessource('ContactAttempt.Failed'), 'md-toast bg-red', 'fas fa-exclamation');
            }
          });
        }
      });
    }
  }

  initialize(): void {
    const SELF = this;
    SELF.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    this.leftTabs = [
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.Tab1');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Tab1Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.Tab2');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Tab2Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.Tab3');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Tab3Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.Tab4');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Tab4Icon');
        }
      },
    ];
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getResource('Tabs.Attachments.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Attachments.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('DOCUMENTREAD');
        }
      },
      {
        get caption(): string {
          return 'Bericht';
        },
        get icon_class(): string {
          return 'fal fa-clipboard-list';
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RQUESTVREAD')
            && !SELF.excSecurity.isFeatured('RPHOTOREAD')
            && !SELF.excSecurity.isFeatured('RCALCVREAD');
        }
      },
      {
        get caption(): string {
          return 'Formulare';
        },
        get icon_class(): string {
          return 'fal fa-pen-field';
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('FORMVREAD');
        },
        get hidden(): boolean {
          return !SELF.excSecurity.isFeatured('FORMVREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Receipts.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Receipts.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RECEIPTREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.ServiceRecords.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.ServiceRecords.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('DEVELOPMENT'); // war LERFNAV
        },
        get hidden(): boolean {
          return !SELF.excSecurity.isFeatured('DEVELOPMENT'); // war LERFNAV
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.DialogueQuestions.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.DialogueQuestions.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Progress.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Progress.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Task.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Task.Icon');
        }
      },
    ];
  }

  /* Lifecycle Hooks*/
  ngOnInit(): void {
    this.TaskSummary = this.dataSvc.Task.Summary.Get(this.Data, undefined, {Events: this.Events});
    this.registerEvents();
    this.initialize();
  }

  //#region TaskWorkspace
  changeEditor(): void {
    this.overlaySrv.show(
      'OverlayDispositionComponent', {vorgID: this.TaskSummary?.ID}, true
    ).subscribe((ret: any) => {
      if (ret && ret.assigned) {
        this.TaskSummary?.LoadSummary();
      }
    });
  }

  changeCoEditor(): void {
    const SELF = this;
    SELF.excRest.get(SELF.excRest.computeUrl('OeR_List_User')).subscribe(
      (response: any) => {
        if (response) {
          this.modal.show('ModalCoEditorComponent', response.data).subscribe((modalResponse: any) => {
            if (modalResponse) {
              SELF.excRest.put(SELF.excRest.computeUrl('TaskU_CoEditor',
                  {oeID: modalResponse.oeID, vorgID: SELF.TaskSummary?.ID}),
                modalResponse)
                // tslint:disable-next-line:no-shadowed-variable
                .subscribe((response: any) => {
                  if (response.success) {
                    this.TaskSummary?.LoadSummary();
                    this.modal.showToast(
                      SELF.getRessource('ChangeCoEditor.Success')
                      , 'md-toast', 'fas fa-check-circle');
                  } else {
                    this.modal.showToast(
                      SELF.getRessource('ChangeCoEditor.Fail')
                      , 'md-toast', 'fas fa-exclamation');
                  }
                });
            }
          });
        }
      }
    );
  }

  deleteCoEditor(): void {
    this.modal.showSimple(this.getRessource('ChangeCoEditor.RemoveTitle')
      , this.getRessource('ChangeCoEditor.RemoveQuestion')
      , true, true
      , this.getRessource('ChangeCoEditor.Remove')
      , this.getGlobal('Cancel')
    ).subscribe(
      (response: any) => {
        if (response) {
          this.excRest.put(this.excRest.computeUrl('TaskU_CoEditor',
              {oeID: '00000000-0000-0000-0000-000000000000', vorgID: this.TaskSummary?.ID}),
            response)
            .subscribe((response2: any) => {
              if (response2.success) {
                this.TaskSummary?.LoadSummary();
                this.modal.showToast(
                  this.getRessource('ChangeCoEditor.RemoveSuccess')
                  , 'md-toast', 'fas fa-check-circle');
              } else {
                this.modal.showToast(
                  this.getRessource('ChangeCoEditor.RemoveFail')
                  , 'md-toast', 'fas fa-exclamation');
              }
            });
        }
      }
    );
  }

  showWorklistUpdateModalWithRow(index: any): void {
    if (this.excSecurity.isFeatured('SCHEDULEEDIT')) {
      // row.apiSollDatum = this.optimizeDateTimeFormat(row.apiSollDatum)
      this.appSvc.Schedule.Update.OpenModal({
        worklistData: this.TaskSummary?.workList?.data,
        worklistItem: this.TaskSummary?.workList?.data[index]
      }, {Events: this.Events});
    }
  }

  changeSchadenort(): void {
    if (!this.excSecurity.isFeatured('CASEEDIT')) {
      return;
    }
    this.modal.show(
      'ModalLocationCreateComponent',
      {new: true, adr_enmIdent_AdresseTyp: 5},
      true
    ).subscribe(data => {
      if (data) {
        const url = this.excRest.computeUrl(
          'OeAdresseC_Schadenort',
          {oeID: '00000000-0000-0000-0000-000000000000'}
        );
        this.excRest.post(url, data).subscribe((ret: any) => {
          if (ret?.data?.Schadenort?.adrID) {
            const caseData = this.appSvc.helperObj.clone(
              this.TaskSummary?.caseDetails?.data
            );
            caseData.aue_adrID_SchadenOrt = ret.data.Schadenort.adrID;
            this.caseDataSvc.Case.Update(caseData).subscribe(() => {
              this.TaskSummary?.LoadSummary();
            });
          }
        });
      }
    });
  }

  showObjectImageUpdateModal(): void {
    this.appSvc.Document.Preview.OpenModal({
      objID: this.TaskSummary?.ID,
      attID: this.TaskSummary?.caseDetails?.data?.aueObjektbild_dokID,
      CustomAction: {
        caption: this.getResource('caption'),
        click: (item: any) => {
          if (item) {
            const data = {aueObjektbild_dokID: item.dokID};
            this.excRest.put(this.excRest.computeUrl('CaseU_ObjectPic', {auID: this.TaskSummary?.caseDetails?.data.auID})
              , data).subscribe((response: any) => {
              if (response.success) {
                this.TaskSummary?.LoadSummary();
                this.modal.showToast(
                  this.getRessource('ChangeObjectPic.Success'),
                  'md-toast', 'fas fa-check-circle');
              } else {
                this.modal.showToast(
                  this.getRessource('ChangeObjectPic.Fail'),
                  'md-toast', 'fas fa-check-circle');
              }
            });
          }
        }
      },
      allowedMIME: ['image/*']
    }, {Events: this.Events});
  }

  openDialogueQuestions(): void {
    this.appSvc.DialogueQuestion.OpenModal(
      {vorgID: this.TaskSummary?.ID, questions: this.TaskSummary?.dialogueQuestions.data},
      {Events: this.Events});
  }

  isWorkflowActive(): boolean {
    return this.workFlowMenu.findIndex(e => e.visible) !== -1;
  }

  createNewTaskWorklist(): void {
    if (this.excSecurity.isFeatured('SCHEDULECREATE')) {
      this.appSvc.Schedule.Create.OpenModal(
        {worklistData: this.TaskSummary?.workList?.data, taskID: this.TaskSummary?.ID}
        , {Events: this.Events}
      );
    }
  }

  taskStateChange(
    modalData: {
      title: string,
      message: string,
      actions: [{
        btnText: string, disabled: false
        rtValue: boolean
      }]
    }): Observable<any> {
    if (!this.excSecurity.isFeatured('TASKSTATCHANGE')) {
      modalData.title =
        this.getRessource(modalData.title).startsWith('TaskWorkspaceV2Component') ?
          modalData.title
          : this.getRessource(modalData.title);
      modalData.message =
        this.getRessource(modalData.message).startsWith('TaskWorkspaceV2Component') ?
          modalData.message
          : this.getRessource(modalData.message);
      modalData.actions
        .forEach((btn: any) => {
          if (!this.getRessource(btn.btnText).startsWith('TaskWorkspaceV2Component')) {
            btn.btnText = this.getRessource(btn.btnText);
          }
        });
      return this.modal.show('ModalTaskStateChangeComponent', modalData);
    }
    return new Observable(observer => {
      observer.next(true);
    });
  }

  openCase(): void {
    if (!this.excSecurity.isFeatured('CASEREAD')) {
      return;
    }
    this.appSvc.Case.Workspace.OpenTabV2(this.TaskSummary.taskDetails.data.vorg_auID);
  }

  OpenDetailHistoryModal(): void {
    if (!this.TaskSummary.isLoading) {
      this.modal
        .show('ModalDetailHistoryComponent', {ID: this.TaskSummary?.ID, Object: this.TaskSummary.taskDetails.data})
        .subscribe(() => {
        });
    }
  }

  openFileOverview(): void {
    this.appSvc.Document.Manager.OpenOverlay({vorgID: this.TaskSummary?.ID, Events: this.Events});
  }

  openVideoTool(): void {
    const redirectFn = () => {
      this.excRest.postBasic(this.excRest.computeUrl('JWTR'), {userId: 1400, taskId: this.TaskSummary.ID}).subscribe(
        res => {
          const url = res.VideoCallUrl;
          const tok = res.token;
          window.open(this.excRest.computeUrl(url, {jwt: tok, task_id: this.TaskSummary.ID}), '_blank');
        }
      );
    };
    const digitaleSchadenaufnahmeIdent = 99; // todo new enumeration
    const currentVorgangTyp = this.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangTyp;
    const data = this.TaskSummary?.taskDetails?.data;

    if (currentVorgangTyp === digitaleSchadenaufnahmeIdent) {
      redirectFn();
    } else {
      this.modal.showSimple(
        'Vorgangstyp ändern'
        , 'Der Vorgangstyp ist nicht ‚Digitale Schadenaufnahme. Soll der Vorgangstyp geändert werden?'
        , true
        , true
        , 'Ja'
        , 'Nein')
        .subscribe((confirmed: boolean) => {
          if (confirmed) {
            const editModel = {
              vorgID: data?.vorgID,
              vorgUPT: data?.vorgUPT,
              vorg_enmIdent_VorgangTyp: digitaleSchadenaufnahmeIdent
            };
            this.taskDataSvc.Task.Edit(editModel).subscribe((updated: any) => {
              if (updated) {
                this.TaskSummary?.LoadSummary();
                redirectFn();
              }
            });
          }
          else {
            redirectFn();
          }
        });
    }
  }

  changeLastQSAuditor(): void {
    const SELF = this;

    SELF.excRest.get(SELF.excRest.computeUrl('OeR_List_User')).subscribe(
      (response) => {
        if (response) {
          this.modal.show('ModalCoEditorComponent', response.data).subscribe((modalResponse: any) => {
            if (modalResponse) {
              SELF.excRest.put(SELF.excRest.computeUrl('CaseU_LastQSAuditor',
                  {oeID: modalResponse.oeID, auID: SELF.TaskSummary?.caseDetails?.data?.auID}),
                modalResponse)
                // tslint:disable-next-line:no-shadowed-variable
                .subscribe((response: any) => {
                  if (response.success) {
                    this.TaskSummary?.LoadSummary();
                    this.modal.showToast(
                      SELF.getRessource('ChangeLastQSAuditor.Success')
                      , 'md-toast', 'fas fa-check-circle');
                  } else {
                    this.modal.showToast(
                      SELF.getRessource('ChangeLastQSAuditor.Fail')
                      , 'md-toast', 'fas fa-exclamation');
                  }
                });
            }
          });
        }
      }
    );
  }

  onClickOpenTaskCheckview(task: any): void {
    if (this.excSecurity.isFeatured('TASKREAD')) {
      this.appSvc.Task.Workspace.OpenTabV2(task.vorgID);
    }
  }

  apiWarnings(): void {
    if (this.TaskSummary?.workList?.data && this.TaskSummary?.workList?.data.length > 0) {
      for (const apiListElement of this.TaskSummary?.workList?.data) {
        Object.assign(apiListElement, {
          apiSollDatumWTooltip: '',
          apiPlanDatumWTooltip: '',
          apiSollDatumShowWarning: false,
          apiPlanDatumShowWarning: false
        });

        if (this.excSecurity.isFeatured('SCHEDULESHOWESC')) {
          // Plandatum überschreitet Solldatum
          if (apiListElement.apiPlanDatum
            && apiListElement.apiSollDatum
            && apiListElement.apiPlanDatum > apiListElement.apiSollDatum) {
            apiListElement.apiPlanDatumShowWarning = true;
            apiListElement.apiPlanDatumWTooltip = this.getRessource('Ablaufplan.PlanSolldatum');
          }

          // Solldatum überschritten
          if (apiListElement.apiSollDatum
            && new Date(apiListElement.apiSollDatum) < new Date()) {
            apiListElement.apiSollDatumShowWarning = true;
            apiListElement.apiSollDatumWTooltip = this.getRessource('Ablaufplan.HeuteSolldatum');
          }

          // Vorgangsfrist überschritten
          if (apiListElement.apiSollDatum
            && new Date(apiListElement.apiSollDatum) > new Date(this.TaskSummary?.taskDetails?.data?.vorgFrist)) {
            if (apiListElement.apiSollDatumShowWarning) {
              apiListElement.apiSollDatumWTooltip += '\n\r';
            } else {
              apiListElement.apiSollDatumShowWarning = true;
            }
            apiListElement.apiSollDatumWTooltip += this.getRessource('Ablaufplan.FristSolldatum');
          }
        }
      }
    }
  }

  saveEdit(originalTaskModel: any): void {
    if (this.excSecurity.isFeatured('TASKEDIT')) {
      const modelChanged = this.editFunctions.compareEditTaskModels(originalTaskModel);
      if (modelChanged) {
        this.taskDataSvc.Task.Edit(this.editFunctions.editTaskModel).subscribe((updated: any) => {
          if (updated) {
            this.TaskSummary?.LoadSummary();
            this.modal.showToast(
              this.getRessource('SaveEdit.Success')
              , 'md-toast', 'fas fa-check-circle');
            this.editFunctions.editMode = false;
          } else {
            this.modal.showToast(
              this.getRessource('SaveEdit.Failed')
              , 'md-toast', 'fas fa-exclamation');
            this.editFunctions.editMode = false;
          }
        });
      } else {
        this.editFunctions.editMode = false;
      }
    }
  }

  openTaskStateModal(): void {
    if (this.excSecurity.isFeatured('TASKSTATCHANGE')) {
      const task = this.TaskSummary.taskDetails.data;
      const enumList = this.enumSvc.getEnumerationList('VorgangStatus');
      /**/
      if (task && enumList?.length > 0) {
        this.modal.show('ModalTaskStateChangeCommentComponent', {
          taskState: task.vorg_enmIdent_VorgangStatus,
          enums: enumList
        })
          .subscribe((modalResponse: any) => {
            if (modalResponse && task.vorg_enmIdent_VorgangStatus !== modalResponse.selectedStateEnmIdent) {
              /*different State was selected*/
              if (task.vorg_enmIdent_VorgangStatus !== modalResponse.selectedStateEnmIdent) {
                this.taskDataSvc.Task.ManualStateChange(this.TaskSummary.taskDetails.data
                  , modalResponse.selectedStateEnmIdent
                  , modalResponse.stateChangeComment)
                  .subscribe(() => {
                    this.TaskSummary?.LoadSummary();
                    this.modal.showToast(
                      this.getRessource('StateChange.Success')
                      , 'md-toast', 'fas fa-check-circle');
                  });
              }
              /*no Response from Modal*/
            } else if (modalResponse && task.vorg_enmIdent_VorgangStatus === modalResponse.selectedStateEnmIdent) {
              this.modal.showToast(
                this.getGlobal('NoChanges')
                , 'md-toast', 'fas fa-exclamation');
            }
          });
      }
    }
  }

  createNewQuestionnaireVersion(id: any): void {
    const data = {vorgID: this.TaskSummary?.ID, qcnfID: id};
    this.appSvc.QuestionnaireVersion.OpenModal(data, {Events: this.Events});
  }


  createNewPhotoDoc(): void {
    this.appSvc.Task.PhotoDocumentation.OpenTab(
      {FKID: this.TaskSummary.taskDetails.data.vorgID, aueSchadenNr: this.TaskSummary.caseDetails.data.aueSchadenNr},
      {Events: this.Events}
    );
  }

  addVNData(): void {
    this.appSvc.VnData.AddData(this.TaskSummary, {Events: this.Events});
  }

  createNewCalculationVersion(row: any): void {
    const sameType: any[] = this.TaskSummary?.calculationVersion?.data.filter((line: any) => {
      return line.cv_ctID === row.ctID;
    });
    if (sameType.length === 0) {
      this.createNewCalculationFromTemplate(row);
      return;
    } else {
      const lastOfType: any = sameType.reduce((max: any, current: any) => {
        return current.cvLCD > max.cvLCD ? current : max;
      });
      if ([10, 20].includes(lastOfType.cvCalculationVersionStatus_enmIdent)) {
        this.modal.showSimple('Neue Kalkulation aus Datenquelle'
          , 'Es wurde im Auftrag bereits eine Kalkulation mit diesem Typ gefunden, die bereits abgeschlossen ist. ' +
          'Möchten Sie eine neue Kalkulation mit den übernommenen Werten anlegen?'
          , true, true, 'Ja, anlegen', 'Abbrechen')
          .subscribe((response: any) => {
            if (response) {
              this.createNewCalculationWithPreset(lastOfType, row);
            }
          });
      } else {
        this.modal.showSimple('Kalkulation bereits vorhanden'
          , 'Es wurde im Auftrag bereits eine Kalkulation mit diesem Typ gefunden, die noch offen ist. ' +
          'Möchten Sie die vorhandene Kalkulation öffnen?'
          , true, true, 'Ja, öffnen', 'Abbrechen')
          .subscribe((response: any) => {
            if (response) {
              this.openExistingCalculationVersion(lastOfType);
            }
          });
      }
    }
  }

  openExistingCalculationVersion(row: any): void {
    const data = {
      cvID: row.cvID,
      cv_ctID: row.ctID,
      cv_fkID: row.cv_FKID,
      sourceID: this.TaskSummary?.taskDetails?.data?.vorgID
    };


    this.appSvc.Calculation.Version.OpenTab(data, {Events: this.Events});
  }

  createNewCalculationWithPreset(presetCalculation: any, template: any): void {
    const data = {
      cvID: presetCalculation.cvID,
      cv_ctID: template.ctID,
      cv_fkID: this.TaskSummary?.taskDetails?.data?.vorgID,
      sourceID: this.TaskSummary?.taskDetails?.data?.vorgID,
      cvData: presetCalculation.cvData,
      cvName: 'Vorlage von ' + presetCalculation.cvName,
      cvDescription: presetCalculation.cvDescription,
      isNewFromPreset: true
    };
    this.appSvc.Calculation.Version.OpenTab(data, {Events: this.Events});
  }

  createNewCalculationFromTemplate(row: any): void {
    const data = {
      cv_ctID: row.ctID,
      cv_fkID: this.TaskSummary?.taskDetails?.data?.vorgID,
      sourceID: this.TaskSummary?.taskDetails?.data?.vorgID,
      cvName: row.ctName,
      isNew: true
    };

    this.appSvc.Calculation.Version.OpenTab(data, {Events: this.Events});
  }

  createNewFormularVersion(row: any): void {
    if (this.excSecurity.isFeatured('FORMVCREATE')) {
      const data = {fkID: this.TaskSummary?.taskDetails?.data?.vorgID, frmTID: row.frmTID, frmTName: row.frmTName};
      this.appSvc.Formular.Version.OpenTab(data, {Events: this.Events});
    }
  }

  createOE(OEtoChange: string
    ,      parentOEID: string = '00000000-0000-0000-0000-000000000000'
    ,      predefinedCRMRolle: number = 0
    ,      predefinedOETyp: number = 0
    ,      isCompany: boolean = false): void {
    const repTable = OEtoChange.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag';
    this.modal.show('ModalOeComponent', {
      new: true,
      showAssignButton: true,
      isCompany,
      oeIDparent: parentOEID,
      predefinedCrmRolle: predefinedCRMRolle,
      predefinedEnmIdentOETyp: predefinedOETyp
    }).subscribe((result: any) => {
      if (result?.OEDetails?.oeID) {
        this.updateOE(OEtoChange, {chosenOE: {oeID: result.OEDetails.oeID}}, repTable);
      }
    });
  }

  changeOE(
    OEtoChange: string,
    parentOEID: string = '00000000-0000-0000-0000-000000000000',
    predefinedCRMRolle: number = 0,
    predfinedOETyp: number = 0
  ): void {
    const repTable = OEtoChange.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag';
    const isWAnspr = OEtoChange.startsWith('aue_oeID_WAnspr');
    let chosenWAnspr = '';
    if (isWAnspr) {
      const whichWAnsprNr = OEtoChange.slice(-1);  /*Kann 1, 2, 3 oder 4 sein*/
      chosenWAnspr = 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion';
    }
    this.openOEModal(predefinedCRMRolle, predfinedOETyp, parentOEID, isWAnspr, OEtoChange, repTable, chosenWAnspr);
  }

  openOEModal(predefinedCRMRolle: number = 0,
              predfinedOETyp: number = 0,
              parentOEID: string,
              isWAnspr: boolean,
              OEtoChange: string,
              repTable: string,
              chosenWAnspr: string
  ): void {
    this.modal.show('ModalChooseOEComponent'
      , {
        oe_CrmRolle: predefinedCRMRolle
        , oe_enmIdent_OETyp: predfinedOETyp
        , isWAnspr: isWAnspr
        , selectedWAnsprEnmIdent: this.TaskSummary?.caseDetails?.data?.[chosenWAnspr]
        , parentOEID: parentOEID
      }).subscribe((modalResponse: any) => {
      if (modalResponse) {
        this.handleOEModalResponse(OEtoChange, modalResponse, repTable);
      }
    });
  }

  private handleOEModalResponse(OEtoChange: string, modalResponse: any, repTable: string): void {
    const isWAnspr = OEtoChange.startsWith('aue_oeID_WAnspr');
    if (isWAnspr) {
      this.updateWAnsprOE(OEtoChange, modalResponse, repTable);
    } else {
      this.updateOE(OEtoChange, modalResponse, repTable);
    }
  }

  private updateOE(OEtoChange: string, modalResponse: any, repTable: string): void {
    const updatedOE = {
      [OEtoChange]: modalResponse.chosenOE.oeID,
      auUPT: this.TaskSummary?.caseDetails?.data?.auUPT
    };
    this.excRest.put(this.excRest.computeUrl('CaseU_SetOE',
        {auID: this.TaskSummary?.caseDetails?.data?.auID}),
      updatedOE)
      .subscribe((UpdateResponse: any) => {
        if (UpdateResponse.success) {
          this.TaskSummary?.LoadSummary();
          this.modal.showToast(
            this.getRessource('ChangeOE.Success'
              , {OEtoChange: this.enumSvc.getFieldCaption(repTable, OEtoChange)})
            , 'md-toast', 'fas fa-check-circle');
        } else {
          this.modal.showToast(
            this.getRessource('ChangeOE.Failure'
              , {OEtoChange: this.enumSvc.getFieldCaption(repTable, OEtoChange)})
            , 'md-toast', 'fas fa-check-circle');
        }
      });
  }

  deleteOE(OEtoDelete: string): void {
    const SELF = this;
    const repTable = OEtoDelete.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag';
    const isWAnspr = OEtoDelete.startsWith('aue_oeID_WAnspr');
    let uiName = '';
    if (isWAnspr) {
      const whichWAnsprNr = OEtoDelete.slice(-1);  /*Kann 1, 2, 3 oder 4 sein*/
      const chosenWAnspr = 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion';
      uiName = this.enumSvc.getEnumerationText('WAnsprPtnrFunktion',
        this.TaskSummary?.caseDetails?.data?.[chosenWAnspr]);
    } else {
      uiName = this.enumSvc.getFieldCaption(repTable, OEtoDelete);
    }
    this.modal.showSimple(
      this.getRessource('DeleteOE.Title', {OEtoDelete: uiName})
      , this.getRessource('DeleteOE.Question', {OEtoDelete: uiName})
      , true, true, this.getRessource('DeleteOE.Remove'), this.getGlobal('Cancel'))
      .subscribe((modalResponse: any) => {
        if (modalResponse) {
          const updatedOE = {
            [OEtoDelete]: '00000000-0000-0000-0000-000000000000',
            auUPT: this.TaskSummary?.caseDetails?.data?.auUPT
          };
          SELF.excRest.put(SELF.excRest.computeUrl('CaseU_SetOE',
              {auID: this.TaskSummary?.caseDetails?.data?.auID}),
            updatedOE)
            .subscribe((UpdateResponse: any) => {
              if (UpdateResponse.success) {
                this.TaskSummary?.LoadSummary();
                this.modal.showToast(
                  SELF.getRessource('DeleteOE.Success'
                    , {OEtoDelete: uiName})
                  , 'md-toast', 'fas fa-check-circle');
              } else {
                this.modal.showToast(
                  SELF.getRessource('DeleteOE.Failure'
                    , {OEtoDelete: uiName})
                  , 'md-toast', 'fas fa-check-circle');
              }
            });
        }
      });
  }

  private updateWAnsprOE(OEtoChange: string, modalResponse: any, repTable: string): void {
    const whichWAnsprNr = OEtoChange.slice(-1);  /*Kann 1, 2, 3 oder 4 sein*/
    const chosenWAnspr = 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion';
    const updatedOE = {
      [OEtoChange]: modalResponse.chosenOE.oeID,
      [chosenWAnspr]: modalResponse.chosenWAnsprEnmIdent,
      auUPT: this.TaskSummary?.caseDetails?.data?.auUPT
    };
    this.excRest.put(this.excRest.computeUrl('CaseU_SetWAnsprOE',
        {auID: this.TaskSummary?.caseDetails?.data?.auID}),
      updatedOE)
      .subscribe((UpdateResponse: any) => {
        if (UpdateResponse.success) {
          this.TaskSummary?.LoadSummary();
          this.modal.showToast(
            this.getRessource('ChangeOE.Success'
              , {OEtoChange: this.enumSvc.getEnumerationText('WAnsprPtnrFunktion', modalResponse.chosenWAnsprEnmIdent)})
            , 'md-toast', 'fas fa-check-circle');
        } else {
          this.modal.showToast(
            this.getRessource('ChangeOE.Failure'
              , {OEtoChange: this.enumSvc.getEnumerationText('WAnsprPtnrFunktion', modalResponse.chosenWAnsprEnmIdent)})
            , 'md-toast', 'fas fa-check-circle');
        }
      });
  }

  openReportBuilderOverlay(): void {
    this.appSvc.ReportBuilder.DocBuilder.OpenTab(
      {vorgID: this.TaskSummary?.taskDetails?.data?.vorgID, Events: this.Events});
  }

  async openWorkspace(index?: number): Promise<void> {
    this.appSvc.Task.Workspace.OpenTab(this.TaskSummary.taskDetails.data.vorgID, {Events: this.Events});
  }


  changeEnum($event: { index: number; value: any }): void {
    if ($event.value.enmName === this.editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName) {
      this.selectedVorgangSubTypIndex = $event.value.enmIdent;
    }
  }

  // changeTaskSubtype($event: { index: number; value: any }): void {
  //   this.selectedVorgangSubTypIndex = $event.index;
  // }
  saveReportFolderStates(sources: string[]): void {
    this.openReportFolder = sources;
  }

  saveAttachmentFolderStates(sources: string[]): void {
    this.openAttachmentFolder = sources;
  }

  getJournalMailAttachment(jmItem: any): any[] {
    try {
      const arr = JSON.parse(jmItem.jmAttachments);
      return arr;
    }
    catch {}
    return [];
  }

  onDblClickJournalMail(index: number): void {
    const jmItem = this.TaskSummary?.journalMail?.data[index];
    if (!jmItem) { return; }
    this.overlaySrv.show(
      'OverlayEmlViewerComponent',
      { uid: this.TaskSummary?.ID, jmID: jmItem.jmID },
      true
    ).subscribe();
  }
}
